import { ModuleTree } from "vuex";
import { State } from "@/typings/store";

// modules
import drawer from "./drawer";
import cargando from "./cargando";
import vistaCargando from "./vistaCargando";
import usuario from "./usuario";
import rutas from "./rutas";
import archivos from "./archivos";

const modules: ModuleTree<State> = {
  archivos,
  cargando,
  drawer,
  rutas,
  usuario,
  vistaCargando,
};

export default modules;
